module.exports = __webpack_public_path__ + "img/share.aea68f57.png";